import { Dispatch } from "redux";

import { getPRPC, setPRPC } from "../../hooks/usePRPC";
import createRPCQuery from "../../utils/createRPCQuery.util";
import session from "../reducers/session";
import account from "../reducers/account";
import prpc from "../reducers/prpc";
import { RootState } from "../store";

import Account from "./Account";
import SubscriptionPool from "./SubscriptionPool";
import { prpcow, setSocketToken, stopReconnect } from "./base";
import { resetInitOrderCard } from "./Order/card";

export default class Session {
	static create(token?: string) {
		return async (dispatch: Dispatch<any>, getState: () => RootState) => {
			const {
				prpc: { connected, token: currentToken },
			} = getState();

			setSocketToken(token ?? getState().session.token?.value);

			if (connected && token === currentToken) return;

			dispatch(prpc.actions.setConnected(false));
			dispatch(prpc.actions.setAuthorized(false));

			const nextToken = token ?? getState().session.token?.value;

			prpcow(
				(connection, isReconnect) => {
					// eslint-disable-next-line no-console

					const sessionToken = connection.session.protocol;

					setPRPC(connection);

					dispatch(prpc.actions.setConnected(true));

					if (connection.theirsModel.auth?.dispatcher?.login) {
						const persistedToken = getState().session.token?.value;
						if (
							persistedToken &&
							persistedToken !== (token ?? nextToken)
						) {
							setSocketToken(persistedToken);
							dispatch(Session.create(persistedToken));
							return;
						}

						dispatch(prpc.actions.setAuthorized(false));

						SubscriptionPool.clear();
					} else {
						dispatch(prpc.actions.setAuthorized(true));
						dispatch(prpc.actions.setToken(sessionToken));

						if (
							isReconnect ||
							SubscriptionPool.subscriptions.length > 0
						) {
							SubscriptionPool.onReconnect(connection);
						}

						const tokenData = getState().session.token;

						if (tokenData) {
							dispatch(Account.me(tokenData.userId));
						}
					}
				},
				() => {
					// eslint-disable-next-line no-console

					dispatch(prpc.actions.setConnected(false));
				},
				nextToken,
			);
		};
	}

	static login(
		username: string,
		password: string,
		errorNotification: () => void,
	) {
		return async (dispatch: Dispatch<any>) => {
			try {
				const prpcSession = getPRPC();

				if (!prpcSession) return;

				const result = await createRPCQuery(() =>
					prpcSession.theirsModel.auth.dispatcher.login({
						login: username,
						password,
					}),
				);

				const token = {
					value: result.token,
					type: result.type,
					userId: result.id,
				};

				setSocketToken(token.value);
				dispatch(prpc.actions.setAuthorized(true));
				dispatch(prpc.actions.setToken(token.value));
				dispatch(session.actions.setToken(token));
				dispatch(Account.me(token.userId));
			} catch (err: any) {
				errorNotification();
			}
		};
	}

	static logout() {
		return (dispatch: Dispatch) => {
			const prpcSession = getPRPC();
			dispatch(session.actions.setToken(undefined));
			dispatch(account.actions.setUser(undefined));
			dispatch(prpc.actions.setAuthorized(false));
			prpcSession?.closeRequest();
			stopReconnect();
			resetInitOrderCard();
		};
	}
}
